import { QUERY_KEYS } from '../../../../constants';
import API_ROUTES from '../../../../constants/apiRoutes';
import useMutateData from '../../../../hooks/useMutateData';

const useWelcomeBonusCommands = () => {
  const { createData, updateData } = useMutateData(API_ROUTES.WELCOME_BONUS, [QUERY_KEYS.welcomeBonus], 'crm');

  return {
    createWelcomeBonus: createData,
    updateWelcomeBonus: updateData,
  };
};

export default useWelcomeBonusCommands;
